import { NgModule, ModuleWithProviders } from "@angular/core";
import {
  MatButtonModule,
  MatCheckboxModule,
  MatSidenavModule,
  MatIconModule,
  MatToolbarModule,
  MatCardModule,
  MatInputModule,
  MatExpansionModule,
  MatSelectModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatTabsModule,
  MatRadioModule,
  MatMenuModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatPaginatorModule,
  MatListModule,
  MatDialogModule,
  MatTreeModule,
  MatTooltipModule
} from "@angular/material";

@NgModule({
  imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatIconModule,
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatExpansionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatRadioModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatChipsModule,
    MatListModule,
    MatDialogModule,
    MatTreeModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatIconModule,
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatExpansionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatRadioModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatChipsModule,
    MatListModule,
    MatDialogModule,
    MatTreeModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule
  ]
})

export class MaterialModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: MaterialModule
    }
  }
}
